var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNoImages(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 174,
    viewBox: "0 0 217 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4198 129.613L61.9966 130.237C59.6192 130.571 57.4211 128.911 57.087 126.528L44.9874 40.2372C44.6533 37.8543 46.3097 35.6511 48.6871 35.3162L133.704 23.3404C136.081 23.0055 138.279 24.6657 138.613 27.0486C138.613 27.0486 139.387 32.566 139.653 34.4639",
    fill: "#1B1A1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1654 124.809L65.1489 125.381C62.9901 125.689 60.997 124.184 60.697 122.021L49.8349 43.6777C49.535 41.5143 51.0418 39.5112 53.2006 39.2037L130.4 28.2059C132.558 27.8984 134.552 29.4028 134.852 31.5662L135.785 38.2985C135.835 38.6628 139.17 62.8433 145.789 110.84C146.121 113.25 144.463 115.477 142.086 115.814C142.06 115.818 142.035 115.821 142.009 115.824L69.1654 124.809Z",
    fill: "#2E3034"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9966 130.237C59.6192 130.571 57.4211 128.911 57.087 126.528L44.9874 40.2372C44.6533 37.8543 46.3097 35.6511 48.6871 35.3162L133.704 23.3404C136.081 23.0055 138.279 24.6657 138.613 27.0486C138.613 27.0486 139.387 32.566 139.653 34.4639",
    stroke: "#333236",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0677 43.5955C81.2261 42.085 82.5789 40.9895 84.0893 41.1486L170.161 50.216C171.672 50.3751 172.768 51.7286 172.61 53.2391L163.447 140.611C163.289 142.121 161.936 143.217 160.426 143.058L74.3537 133.99C72.8433 133.831 71.7472 132.478 71.9056 130.967L81.0677 43.5955Z",
    fill: "#1B1A1F",
    stroke: "#333236",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6334 53.2434C88.8062 51.5956 90.282 50.4005 91.9298 50.5741L160.537 57.8016C162.185 57.9752 163.38 59.4517 163.207 61.0995L157.131 119.045C156.958 120.693 155.482 121.888 153.835 121.715L85.2277 114.487C83.58 114.314 82.3843 112.837 82.5571 111.189L88.6334 53.2434Z",
    fill: "#1B1A1F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.9176 97.7581L102.807 90.3965C104.442 89.2913 106.639 89.5444 107.981 90.9925L116.031 99.6782C116.389 100.065 116.986 100.107 117.395 99.7751L134.423 85.9451C136.272 84.4438 139.015 84.8814 140.306 86.8834L151.361 104.02L152.918 106.626L152.165 115.567C152.117 116.127 151.617 116.538 151.058 116.476L88.9815 109.563C88.4399 109.503 88.0461 109.02 88.096 108.477L88.9244 99.46L91.9176 97.7581Z",
    fill: "#2E3034"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8765 53.3744C89.9773 52.4131 90.8382 51.716 91.7994 51.8172L160.406 59.0448C161.368 59.146 162.065 60.0073 161.964 60.9686L155.888 118.914C155.787 119.876 154.926 120.573 153.965 120.471L85.3581 113.244C84.3969 113.143 83.6994 112.281 83.8002 111.32L89.8765 53.3744Z",
    stroke: "#333236",
    strokeWidth: 2.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.52058,
    cy: 6.53528,
    rx: 6.52058,
    ry: 6.53528,
    transform: "matrix(0.994497 0.104767 -0.104291 0.994547 99.4717 64.5117)",
    fill: "#2E3034",
    stroke: "#2E3034",
    strokeWidth: 2.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoImages);
export default __webpack_public_path__ + "static/media/icon-no-images.56d139399e559cbae68e29a14e101265.svg";
export { ForwardRef as ReactComponent };